import { BaseService } from './BaseService';

export class PushLogService extends BaseService {
    async getChurnNotifications({ offset, limit, search, templateKey, opened } = {}) {
        const params = this.buildQueryString({ offset, limit, search, templateKey, opened });
        return this.get(`/push-logs${params}`, true);
    }

    buildQueryString(params = {}) {
        const query = Object.entries(params)
            .filter(([, value]) => value !== undefined && value !== null && value !== '')
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');

        return query ? `?${query}` : '';
    }
}
